import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Toast from '../../controls/BaseToast';
import { BaseCheckBox } from '../../controls/BaseCheckBox';
import { DefaultImage, LeftRightOption } from '../../infrastructure/AppConstants';
import orderService from '../OrderService';

export class EardrumOption extends Component {
    static displayName = EardrumOption.name;
    constructor(props) {
        super(props);
        let leftValue = "-1";
        let rightValue = "-1";
        let value = this.props.value;
        if (value) {
            var vals = value.split(';');
            if (vals.length == 2) {
                leftValue = vals[0];
                rightValue = vals[1];
            }
        }
        this.state = { leftValue: leftValue, rightValue: rightValue };
        this.handleLeftChange = this.handleLeftChange.bind(this);
        this.handleRightChange = this.handleRightChange.bind(this);
    }

    handleLeftChange(e) {       
        let checked = e.target.checked;
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let leftRightOption = this.props.leftRightOption;
        if (leftRightOption === LeftRightOption.BothEarsOption) {
            let cLValue = this.state.leftValue;
            let cRValue = this.state.rightValue;
            if ((cLValue !== "-1" && cRValue !== "-1" && cLValue && value && cLValue.substr(0, 1) != value.substr(0, 1)) ||
                (cLValue === "-1" && cRValue !== "-1" && cRValue && value && cRValue.substr(0, 1) != value.substr(0, 1))) {
                Toast.error("EarMoldSelWarning");
                return;
            }
        }
       
        let leftValue = value;
        if (!checked) {
            leftValue = '-1';
        }

        this.setState({ leftValue: leftValue }, () => {
            var handle = this.props.onSelectValueChanged;
            if (handle) {
                var v = this.state.leftValue + ';' + this.state.rightValue;
                handle(v);
            }
        });

    }

    handleRightChange(e) {        
        let checked = e.target.checked;
        const target = e.target;
        const value = target.value;
        const name = target.name;

        let leftRightOption = this.props.leftRightOption;
        if (leftRightOption === LeftRightOption.BothEarsOption) {
            let cLValue = this.state.leftValue;
            let cRValue = this.state.rightValue;
            if ((cLValue !== "-1" && cRValue !== "-1" && cRValue && value && cRValue.substr(0, 1) != value.substr(0, 1)) ||
                (cLValue !== "-1" && cRValue === "-1" && cLValue && value && cLValue.substr(0, 1) != value.substr(0, 1))) {
                Toast.error("EarMoldSelWarning");
                return;
            }
        }

        let rightValue = value;
        if (!checked) {
            rightValue = '-1';
        }

        this.setState({ rightValue: rightValue }, () => {
            var handle = this.props.onSelectValueChanged;
            if (handle) {
                var v = this.state.leftValue + ';' + this.state.rightValue;
                handle(v);
            }
        });

    }

    rendRow(length, option, enclosureTypes, handleLeftChange, handleRightChange, leftValue, rightValue) {
        return (<tr>
            <td rowSpan={length} className="border border-gray-600">
                <span><FormattedMessage id="HardEardrumMaterial" /></span>
            </td>
            <td className="border border-gray-600">
                <span>{option.color}</span>
            </td>
            {enclosureTypes.map(e =>
                <td className="border border-gray-600 text-center leading-none" colSpan="2">
                    <div className="grid grid-cols-2 justify-items-center">
                        <BaseCheckBox onChange={handleLeftChange} value={e.id} checked={e.id === leftValue}></BaseCheckBox>
                        <BaseCheckBox onChange={handleRightChange} value={e.id} checked={e.id === rightValue}></BaseCheckBox>
                    </div>
                </td>

            )}
        </tr>);
    }

    render() {
        let enclosureTypes = this.props.enclosureTypes;
        if (!enclosureTypes) {
            return null;
        }
        let hardEardrumColorOptions = this.props.hardEardrumColorOptions;
        let softEardrumColorOptions = this.props.softEardrumColorOptions;
        let leftValue = this.state.leftValue;
        let rightValue = this.state.rightValue;
        let handleLeftChange = this.handleLeftChange;
        let handleRightChange = this.handleRightChange;
        let lMaterial = "";
        let lColorId = "";
        let rMaterial = "";
        let rColorId = "";
        if (leftValue) {
            var arr = leftValue.split(',');
            lMaterial = arr[0];
            lColorId = arr[2];
        }
        if (rightValue) {
            var arr = rightValue.split(',');
            rMaterial = arr[0];
            rColorId = arr[2];
        }
        let leftRightOption = this.props.leftRightOption;

        var title = this.props.title        
        if (title === 'RIC') {
            enclosureTypes = this.props.enclosureTypes.filter(enclosureType => !enclosureType.name.includes('IF'));
        }
        else if (title === 'IF'&& !this.props.showAll) {
            enclosureTypes = this.props.enclosureTypes.filter(enclosureType => enclosureType.name.includes('IF'));
        }

        let earmoldCategory = this.props.earmoldCategory;

        return (
            <table {...this.props} >
                <tbody>
                    <tr>
                        <td style={{ minWidth: 47 }} className={((title === 'RIC' || title === 'IF' ) ? "bg-blue-300" :
                            "bg-red-300") + " border border-gray-600 w-10 font-bold"}>
                            <span>{title}</span>
                    </td>
                        <td colSpan={enclosureTypes.length * 2 + 1} className="border border-gray-200 bg-gray-100 px-1 font-bold">
                            <span><FormattedMessage id={this.props.desc} /></span>
                    </td>
                </tr>
                <tr>
                        <td className="border border-gray-200">
                            <span><FormattedMessage id="Material"/></span>
                    </td>
                        <td className="border border-gray-200 pl-1">
                            <span><FormattedMessage id="Color" /></span>
                    </td>
                        {enclosureTypes.map((e, index) =>
                            <td colSpan="2" key={ index} className="border border-gray-200 p-0">
                            <table className="w-full text-xs">
                                <tbody>
                                    <tr>
                                            <td colSpan="2">
                                                <img src={e.imageUrl} onError={(e) => { e.target.src = DefaultImage }} className="max-w-10 max-h-10 -my-0 mx-auto" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" className="text-center">
                                            <span>{e.name}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="flex items-center justify-center">
                                                    <span className="mx-auto"><FormattedMessage id="Left" /></span>
                                                    <span className="mx-auto text-white inline-block bg-blue-500 rounded-full h-4 w-4 lg:h-4 lg:w-4 flex items-center justify-center">L</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="flex items-center justify-center">
                                                    <span className="mx-auto"><FormattedMessage id="Right" /></span>
                                                    <span className="mx-auto text-white inline-block bg-red-500 rounded-full h-4 w-4 lg:h-4 lg:w-4 flex items-center justify-center">R</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    )}
                </tr>
                {
                        hardEardrumColorOptions.map(function (o, index) {
                            
                        if (index === 0) {                            
                            //return this.rendRow(hardEardrumColorOptions.length, o, enclosureTypes, this.handleLeftChange, this.handleRightChange, this.state.leftValue, this.state.rightValue);
                            return (<tr key={ index}>
                                <td rowSpan={hardEardrumColorOptions.length} className={"border border-gray-200 " + ((lMaterial === "0" || rMaterial === "0") ? "bg-indigo-100" : "")}>
                                    <span><FormattedMessage id="HardEardrumMaterial" /></span>
                                </td>
                                <td className={"border border-gray-200 pl-1 " + ((lColorId === o.id || rColorId === o.id) ? "bg-indigo-100" : "")}>
                                    <span className="truncate">{o.color}</span>
                                </td>
                                {enclosureTypes.map((e,index) =>
                                    <td key={ index} className="border border-gray-200 text-center leading-none" colSpan="2">
                                        <div className="grid grid-cols-2 justify-items-center">
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.RightEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleLeftChange} value={"0" + ',' + e.id + ',' + o.id} checked={("0" + ',' + e.id + ',' + o.id) === leftValue}></BaseCheckBox>
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.LeftEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleRightChange} value={"0" + ',' + e.id + ',' + o.id} checked={("0" + ',' + e.id + ',' + o.id) === rightValue}></BaseCheckBox>
                                        </div>
                                    </td>

                                )}


                            </tr>);
                        }
                        else {
                            return (<tr key={ index}>
                                <td className={"border border-gray-200 pl-1 " + ((lColorId === o.id || rColorId === o.id) ? "bg-indigo-100" : "")}>
                                    <span className="truncate">{o.color}</span>
                                </td>
                                {enclosureTypes.map((e,index) =>
                                    <td key={index} className="border border-gray-200 text-center leading-none" colSpan="2">
                                        <div className="grid grid-cols-2 justify-items-center">
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.RightEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleLeftChange} value={"0" + ',' + e.id + ',' + o.id} checked={("0" + ',' + e.id + ',' + o.id) === leftValue}></BaseCheckBox>
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.LeftEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleRightChange} value={"0" + ',' + e.id + ',' + o.id} checked={("0" + ',' + e.id + ',' + o.id) === rightValue}></BaseCheckBox>
                                        </div>
                                    </td>

                                )}
                            </tr>);
                        }

                    })
                }
                {
                        softEardrumColorOptions.map(function (o, index) {
                           
                        if (index === 0) {
                            return (<tr key={ index}>
                                <td rowSpan={softEardrumColorOptions.length} className={"border border-gray-200 " + ((lMaterial === "1" || rMaterial === "1") ? "bg-indigo-100" : "")}>
                                    <span><FormattedMessage id="SoftEardrumMaterial" /></span>
                                </td>
                                <td className={"border border-gray-200 pl-1 " + ((lColorId === o.id || rColorId === o.id)  ? "bg-indigo-100" : "")}>
                                    <span className="truncate">{o.color}</span>
                                </td>
                                {enclosureTypes.map((e,index) =>
                                    <td key={ index} className="border border-gray-200 text-center leading-none" colSpan="2">
                                        <div className="grid grid-cols-2 justify-items-center">
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.RightEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleLeftChange} value={"1" + ',' + e.id + ',' + o.id} checked={("1" + ',' + e.id + ',' + o.id) === leftValue}></BaseCheckBox>
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.LeftEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleRightChange} value={"1" + ',' + e.id + ',' + o.id} checked={("1" + ',' + e.id + ',' + o.id) === rightValue}></BaseCheckBox>
                                        </div>
                                    </td>

                                )}
                            </tr>);
                        }
                        else {
                            return (<tr key={ index}>
                                <td className={"border border-gray-200 pl-1 " + ((lColorId === o.id || rColorId === o.id) ? "bg-indigo-100" : "")}>
                                    <span className="truncate">{o.color}</span>
                                </td>
                                {enclosureTypes.map((e, index) =>
                                    <td key={ index} className="border border-gray-200 text-center leading-none" colSpan="2">
                                        <div className="grid grid-cols-2 justify-items-center">
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.RightEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleLeftChange} value={"1" + ',' + e.id + ',' + o.id} checked={("1" + ',' + e.id + ',' + o.id) === leftValue}></BaseCheckBox >
                                            <BaseCheckBox disabled={leftRightOption === LeftRightOption.LeftEarOption || orderService.isNotColorLinkToEarmoldCategory(earmoldCategory, o.id)} onChange={handleRightChange} value={"1" + ',' + e.id + ',' + o.id} checked={("1" + ',' + e.id + ',' + o.id) === rightValue}></BaseCheckBox >
                                        </div>
                                    </td>

                                )}
                            </tr>);
                        }

                    })
                    }
                </tbody>
            </table>

        );
    }
}